module.exports = __webpack_public_path__ + "static/line_loop-5e2c05fffdcc6a7f949a67baf14cdab5.mp4";